export default __webpack_public_path__ + "static/media/noProductIcon.c6045cf3.svg";